var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMechanism(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 51,
    viewBox: "0 0 44 51",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22 .939941c-2.4531 0-4.5234 1.355469-7.5938 2.937499-3.0703 1.58203-7.19136 3.49219-13.62495 4.90625l-.78125.1875v.78125c0 15.32036 5.37109 25.55856 10.75 31.90626 5.3789 6.3476 10.8438 8.875 10.8438 8.875l.4374.2187.4376-.2187s21.5312-11.125 21.5312-40.78126v-.78125l-.7812-.1875c-6.4336-1.41406-10.5547-3.32422-13.625-4.90625-3.0704-1.58203-5.1407-2.937499-7.5938-2.937499zm0 1.999999c1.6445 0 3.5508 1.10547 6.6875 2.71875 2.9805 1.53125 7.1719 3.41016 13.25 4.84371-.3672 27.1172-18.6836 37.2891-19.9687 37.9688-.6211-.3008-4.9493-2.4649-9.7188-8.0938-5.02734-5.9336-10.00391-15.4765-10.1875-29.875 6.07812-1.43355 10.2695-3.31246 13.25-4.84371 3.1367-1.61328 5.043-2.71875 6.6875-2.71875zm7.6875 12.62496-.5313.8438-8.125 12.625-5.375-4.8438-.7187-.6562-1.3437 1.4687.75.6875 6.1874 5.625.875.7813.6563-1 8.7813-13.625.5312-.8438z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanism);
export default __webpack_public_path__ + "static/media/mechanism.efe270c9.svg";
export { ForwardRef as ReactComponent };